const InfiniteMasonry = {
  init (Masonry, imagesLoaded) {

    /*
     * Masonry & Infinite scroll
     * https://codepen.io/desandro/pen/XgRpNr
     */
    if ( $('.masonry').length ) {
      let grid = document.querySelector('.masonry');

      var msnry = new Masonry( grid, {
        itemSelector: '.grid__item', // select none at first
        columnWidth: '.grid__item',
        // gutter: '.grid__gutter-sizer',
        percentPosition: true,
        stagger: 30,
        // nicer reveal transition
        visibleStyle: { transform: 'translateY(0)', opacity: 1 },
        hiddenStyle: { transform: 'translateY(100px)', opacity: 0 },
      });


      // initial items reveal
      // imagesLoaded( grid, function() {
      //   grid.classList.remove('are-images-unloaded');
      //   msnry.options.itemSelector = '.grid__item';
      //   var items = grid.querySelectorAll('.grid__item');
      //   msnry.appended( items );
      // });
    }

    // if ( $('.infinite-scroll').length ) {
    //   let grid = document.querySelector('.infinite-scroll');
    //
    //   // init Infinte Scroll
    //   var infScroll = new InfiniteScroll( grid, {
    //     path: getPenPath,
    //     append: '.grid__item',
    //     outlayer: msnry,
    //     status: '.page-load-status',
    //   });
    // }
  }
};

export default InfiniteMasonry;
